/* Copyright (c) 2020-present CloudIO Inc */

import { addDays } from 'date-fns';

const now = new Date();
const tomorrow = addDays(now, 1);
const nextYear = addDays(now, 365);

export const data = `Name,Some Date,Some Number,Active,Some Date Time,Some YN
"Steve Jobs",${tomorrow
  .toISOString()
  .substring(0, 10)},123.45,true,${tomorrow.toISOString()},Y
"Larry Ellison",${now
  .toISOString()
  .substring(0, 10)},123.45,true,${now.toISOString()},N
"Satya Nadella",${nextYear
  .toISOString()
  .substring(0, 10)},123.45,true,${nextYear.toISOString()},N
`;

export const chartDataJson = JSON.stringify(
  [
    {
      name: 'Steve Jobs',
      someNumber: 30,
      someDate: tomorrow.toISOString().substring(0, 10),
      active: true,
      someDateTime: tomorrow.toISOString(),
      someYn: 'Y',
    },
    {
      name: 'Larry Ellison',
      someNumber: 20,
      someDate: now.toISOString().substring(0, 10),
      active: true,
      someDateTime: now.toISOString(),
      someYn: 'N',
    },
    {
      name: 'Satya Nadella',
      someNumber: 25,
      someDate: nextYear.toISOString().substring(0, 10),
      active: true,
      someDateTime: nextYear.toISOString(),
      someYn: 'N',
    },
  ],
  null,
  '  ',
);
